import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchResultsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('search-results', injector);
  }
}
